export default "__VITE_ASSET__BVJHPquc__"